/**
 * Workbench 内置状态
 *
 * @public
 */
var BuiltinUiState;
(function (BuiltinUiState) {
    // MouseUpEvent = 'mouseUpEvent',
    // Workbench 事件
    /**
     * 是否有互联网连接
     */
    BuiltinUiState["IsOnline"] = "isOnline";
    // Editor 事件
    BuiltinUiState["FocusState"] = "focusState";
    BuiltinUiState["SelectionState"] = "selectionState";
    BuiltinUiState["SelectionTempState"] = "selectionTempState";
    BuiltinUiState["ModelState"] = "modelState";
    BuiltinUiState["ModelTempState"] = "modelTempState";
    // 抽屉菜单状态
    BuiltinUiState["DisableDrawerAnimation"] = "disableDrawerAnimation";
    BuiltinUiState["LeftDrawerOpened"] = "leftDrawerOpened";
    BuiltinUiState["RightDrawerOpened"] = "rightDrawerOpened";
    BuiltinUiState["LeftDrawerInfo"] = "leftDrawerInfo";
    BuiltinUiState["RightDrawerInfo"] = "rightDrawerInfo";
    BuiltinUiState["LeftSubDrawerInfo"] = "leftSubDrawerInfo";
    BuiltinUiState["RightSubDrawerInfo"] = "rightSubDrawerInfo";
    BuiltinUiState["LeftDrawerStyle"] = "leftDrawerStyle";
    BuiltinUiState["RightDrawerStyle"] = "rightDrawerStyle";
    BuiltinUiState["LeftDrawerPersistContent"] = "leftDrawerPersistContent";
    BuiltinUiState["RightDrawerPersistContent"] = "rightDrawerPersistContent";
    BuiltinUiState["LeftDrawerHiddenContent"] = "leftDrawerHiddenContent";
    BuiltinUiState["RightDrawerHiddenContent"] = "rightDrawerHiddenContent";
    // 编辑器区
    BuiltinUiState["EditorZoneMarginLeft"] = "editorZoneMarginLeft";
    BuiltinUiState["EditorZoneMarginRight"] = "editorZoneMarginRight";
    // 主菜单配置
    BuiltinUiState["Menu"] = "menu";
    // 移动端菜单
    BuiltinUiState["MobileMenu"] = "mobileMenu";
    // 上下文菜单配置
    BuiltinUiState["ContextMenu"] = "contextMenu";
    BuiltinUiState["ContextMenuInfo"] = "contextMenuInfo";
    BuiltinUiState["MobileContextMenu"] = "mobileContextMenu";
    BuiltinUiState["MobileContextMenuInfo"] = "mobileContextMenuInfo";
    // 工具栏配置
    BuiltinUiState["Toolbar"] = "toolbar";
    BuiltinUiState["ToolbarSubContainer"] = "toolbarSubContainer";
    BuiltinUiState["ToolbarEvent"] = "toolbarEvent";
    BuiltinUiState["ToolbarDropdownEvent"] = "toolbarDropdownEvent";
    BuiltinUiState["FixToolbarShow"] = "transition.trigger.fixed-toolbar";
    BuiltinUiState["FixToolbarDOMVisible"] = "fixed-toolbar.dom.visible";
    BuiltinUiState["RibbonActiveTab"] = "ribbonActiveTab";
    // subContainer 的聚焦是否由点击触发
    BuiltinUiState["isFocusedByClick"] = "isFocusedByClick";
    // 工具栏容器配置
    BuiltinUiState["MultiLineToolbarContainer"] = "multiLineToolbarContainer";
    // 标题栏配置
    BuiltinUiState["Titlebar"] = "titlebar";
    BuiltinUiState["TitlebarCalculatedWidth"] = "titlebarCalculatedWidth";
    BuiltinUiState["MobileTitlebar"] = "mobileTitlebar";
    BuiltinUiState["TitlebarShow"] = "transition.trigger.titlebar";
    BuiltinUiState["TitlebarFocus"] = "titlebarFocus";
    // 是否进入hover模式
    BuiltinUiState["TitlebarHover"] = "titlebarHover";
    // 设置是否通过监听mousemove关闭titlebar
    BuiltinUiState["TitlebarListenMouseMove"] = "titlebarListenMouseMove";
    BuiltinUiState["TitlebarDOMVisible"] = "titlebar.dom.visible";
    // 移动工具栏
    BuiltinUiState["MobileToolbar"] = "mobileToolbar";
    BuiltinUiState["ShowMobileToolbar"] = "showMobileToolbar";
    BuiltinUiState["MobileToolbarPosition"] = "mobileToolbarPosition";
    BuiltinUiState["MobileToolbarPositionTrigger"] = "mobileToolbarPositionTrigger";
    BuiltinUiState["MobileToolbarConfig"] = "mobileToolbarConfig";
    BuiltinUiState["MobilePanels"] = "mobilePanels";
    BuiltinUiState["MobileSubPanel"] = "mobileSubPanel";
    BuiltinUiState["MobilePanelHeight"] = "mobilePanelHeight";
    BuiltinUiState["MobileStandlonePanel"] = "mobileStandlonePanel";
    BuiltinUiState["MobilePopupPanel"] = "mobilePopupPanel";
    BuiltinUiState["KeyboardHeight"] = "keyboardHeight";
    // 标题栏快捷按钮配置
    BuiltinUiState["ExtraButton"] = "extraButton";
    // 状态栏组件配置
    BuiltinUiState["Statusbar"] = "statusbar";
    // 编辑器视窗
    BuiltinUiState["Surface"] = "surface";
    BuiltinUiState["FloatSurface"] = "floatSurface";
    BuiltinUiState["FloatSurfaceStyle"] = "floatSurfaceStyle";
    // 其它自定义组件
    BuiltinUiState["FloatWidget"] = "floatWidget";
    BuiltinUiState["EmbedWidget"] = "embedWidget";
    BuiltinUiState["WrapWidget"] = "wrapWidget";
    BuiltinUiState["InsertWidget"] = "insertWidget";
    BuiltinUiState["EmbedWidgetContainer"] = "embedWidgetContainer";
    // 总体ui配置服务
    BuiltinUiState["ConfigStatus"] = "configStatus";
    // controller禁用名单
    BuiltinUiState["ControllerStatus"] = "controllerStatus";
    // feature禁用名单
    BuiltinUiState["FeatureStatus"] = "featureStatus";
    // scope禁用名单
    BuiltinUiState["ScopeStatus"] = "scopeStatus";
    // 全部禁用exceotion
    BuiltinUiState["DisableExceptionScopes"] = "disableExceptionScopes";
    // scope禁用名单
    BuiltinUiState["DisableAll"] = "disableAll";
    // 红点配置
    BuiltinUiState["Badge"] = "badge";
})(BuiltinUiState || (BuiltinUiState = {}));

export { BuiltinUiState };
//# sourceMappingURL=builtin-state.js.map
